import React, { useState, useEffect, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { actions } from "../redux/authRedux";
import {
  resetRedux,
  saveBookingCarStatus,
  saveBookingStatus,
  saveComment,
  saveCountCV,
  saveLike,
  saveNotification,
  savePosts,
  saveRefreshSocket,
  saveWorkfollow,
  setResetPost
} from "../redux/Actions";
import noibo from "../assets/img/icon-mybhs/mybhs-logo.png";
import bellIcon from "../assets/img/icon-mybhs/notification-button.png";
import menuIcon from "../assets/img/icon-mybhs/menu-button.png";
import noiboicon from "../assets/img/bhs-noibo.png";
import parse from "html-react-parser";
import Avatar from "../assets/img/figure/admin.jpg";
import { URL_LIST_ALL } from "../configs/api";
import Axios from "axios";
import { jwtDecode } from "jwt-decode";
import wavFile from "../assets/notification.wav";
import { Html5Qrcode } from "html5-qrcode";
import { Modal } from "react-bootstrap";
import _ from "lodash";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import SiderBar from "./SiderBar";

const firebaseConfig = {
  apiKey: "AIzaSyDIE0wmEYGdQm4ABYHehiLsf9XNo6A5YlA",
  authDomain: "noibobhsgroup.firebaseapp.com",
  projectId: "noibobhsgroup",
  messagingSenderId: "149459105288",
  storageBucket: "noibobhsgroup.firebasestorage.app",
  appId: "1:149459105288:web:f37654edc50f88ec5883bd"
};

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
const isSupportedBrowser = "Notification" in window && "serviceWorker" in navigator;

function HeaderBar() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const info = user?.data ?? null;

  const [show, setShow] = useState(false);
  const [showNoti, setShowNoti] = useState(false);

  const [socket, setSocket] = useState(null);
  const [refreshNoti, setRefreshNoti] = useState(false);
  const [listNotification, setListNotification] = useState(null);
  const [countNoti, setCountNoti] = useState(0);
  const [soundPlay, setSoundPlay] = useState(false);
  const [dataNotifi, setDataNotifi] = useState(null);

  const [showQrCode, setShowQrcode] = useState(false);
  const [qrResult, setQrResult] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const qrScannerRef = useRef(null);
  const isStoppingRef = useRef(false);

  // 👉 Wrapper để tự xử lý click outside
  const containerRef = useRef(null);

  // =====================================================================
  // CLICK OUTSIDE FIX — KHÔNG CẦN react-onclickoutside NỮA
  // =====================================================================
  useEffect(() => {
    const handleDocClick = (e) => {
      if (!containerRef.current) return;

      // Nếu click ngoài vùng này -> đóng dropdown
      if (!containerRef.current.contains(e.target)) {
        setShow(false);
        setShowNoti(false);
      }
    };

    document.addEventListener("click", handleDocClick);
    return () => document.removeEventListener("click", handleDocClick);
  }, []);

  // =====================================================================
  // LOGOUT
  // =====================================================================
  const dologout = () => {
    confirmAlert({
      title: "Đăng xuất",
      message: "Bạn có chắc muốn đăng xuất",
      closeOnEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          label: "Đăng xuất",
          onClick: () => {
            dispatch(resetRedux());
            dispatch(actions.login(null));
          }
        },
        { label: "Không" }
      ]
    });
  };

  // =====================================================================
  // WEBSOCKET
  // =====================================================================
  useEffect(() => {
    const connectWebSocket = () => {
      const socketInstance = new WebSocket("wss://socket.bhsgroup.vn");

      socketInstance.onmessage = (evt) => {
        if (!evt.data) return;

        try {
          let data = jwtDecode(evt.data);
          if (!data) return;

          if (data.channel === "bhs_socket") {
            let sound = 1;

            if (data.event === "booking_status") dispatch(saveBookingStatus(data.data));
            if (data.event === "bookingcar_status") dispatch(saveBookingCarStatus(data.data));

            if (data.data.action === "posts_comment") {
              sound = 0;
              dispatch(saveComment(data.data.data_send));
            }
            if (data.data.action === "postlike") {
              sound = 0;
              dispatch(saveLike(data.data.data_send));
            }
            if (data.data.action === "posts") {
              sound = 0;
              dispatch(savePosts(data.data.data_send));
            }
            if (data.data.action === "workfollow") {
              sound = 0;
              dispatch(saveWorkfollow(data.data));
            }
            if (data.data.action === "room_booking" || data.data.action === "car_booking") {
              dispatch(saveNotification({ action: data.data.action, datebooking: data.data.datebooking }));
            }

            if (data.data.to_user_id === user.data.id || data.data.to_user_id === "000") {
              if (data.event === "notifications") {
                setRefreshNoti(data.data);
                if (data.data.node_type !== dataNotifi) setDataNotifi(data.data.node_type);
              }
              dispatch(saveRefreshSocket(data));

              if (sound === 1) setSoundPlay(true);
            }
          }
        } catch { }
      };

      socketInstance.onclose = () => {
        setTimeout(() => connectWebSocket(), 1000);
      };

      setSocket(socketInstance);
    };

    if (!socket) connectWebSocket();

    return () => socket?.close();
  }, [socket]);

  // =====================================================================
  // MARK SEEN
  // =====================================================================
  const markSeen = (id, href = null) => {
    Axios.put(URL_LIST_ALL + "notifications/" + id, { seen: 1 }, user.config)
      .then(() => {
        if (href) {
          window.location.href = href;
        } else {
          setListNotification((prev) =>
            prev.map((item) => (item.id === id ? { ...item, seen: 1 } : item))
          );
        }
      })
      .finally(() => {
        setRefreshNoti(!refreshNoti);
      });
  };

  const markSeenAll = () => {
    Axios.post(URL_LIST_ALL + "seenall", {}, user.config)
      .then(() => {
        document.title = "BHS - Nội bộ";
        setListNotification((prev) => prev.map((i) => ({ ...i, seen: 1 })));
      })
      .finally(() => setRefreshNoti(!refreshNoti));
  };

  // =====================================================================
  // LOAD NOTI LIST
  // =====================================================================
  useEffect(() => {
    if (!user.data) return;

    Axios.get(URL_LIST_ALL + "notifications?limit=30&to_user_code=" + user.data.code, user.config)
      .then((res) => {
        if (res.data.status === "success") {
          const datars = res.data.data;

          setListNotification(datars);

          let count_no_seen = datars.filter((x) => !x.seen).length;
          if (count_no_seen > 99) count_no_seen = 99;
          if (count_no_seen > 0)
            document.title = "BHS - Nội bộ (" + count_no_seen + " thông báo)";
          setCountNoti(count_no_seen);

          if (res.data.countcv) dispatch(saveCountCV(res.data.countcv));

          // Kiểm tra role thay đổi
          if (res.data.roles && user.data.roles) {
            const localRole = structuredClone(JSON.parse(user.data.roles));
            const svRole = JSON.parse(res.data.roles);
            if (!_.isEqual(localRole, svRole)) {
              let newUser = { ...user };
              newUser.data.roles = res.data.roles;
              dispatch(actions.login(newUser));
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }, [user.data, refreshNoti]);

  // =====================================================================
  // PLAY SOUND
  // =====================================================================
  useEffect(() => {
    if (soundPlay) {
      try {
        new Audio(wavFile).play();
      } catch { }
      setSoundPlay(false);
    }
  }, [soundPlay]);

  // =====================================================================
  // PUSH NOTIFICATION LOCAL
  // =====================================================================
  useEffect(() => {
    if (dataNotifi) showNotification(dataNotifi);
  }, [dataNotifi]);

  const showNotification = (message) => {
    const regex = /(<([^>]+)>)/gi;
    message = message.replace(regex, "");

    if (!("Notification" in window)) return;

    if (Notification.permission === "granted") {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification("BHS - Thông báo", {
          body: message,
          icon: noiboicon
        });
      });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          navigator.serviceWorker.ready.then((registration) => {
            registration.showNotification("BHS - Thông báo", {
              body: message,
              icon: noiboicon
            });
          });
        }
      });
    }
  };

  // =====================================================================
  // FIREBASE FCM
  // =====================================================================
  useEffect(() => {
    if (!isSupportedBrowser) return;

    Notification.requestPermission().then((permission) => {
      if (permission !== "granted") return;

      if (!isIOS) {
        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);

        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then((registration) => {
            getToken(messaging, {
              vapidKey:
                "BI_9l_QiAQzNw6mAM3xgmL-DprqG2qEko6xJYS3nfqXKnOxxpTgY64v-VKvRraHxWsAXoKdhFIVuDoTZkgTNF1c",
              serviceWorkerRegistration: registration
            }).catch(() => { });

            onMessage(messaging, (payload) => {
              const { title, body, icon } = payload.notification;
              registration.showNotification(title, {
                body,
                icon: icon || noiboicon
              });
            });
          });
      }
    });
  }, []);

  // =====================================================================
  // QR SCANNER
  // =====================================================================
  useEffect(() => {
    const initQrScanner = async () => {
      if (showQrCode && !qrScannerRef.current) {
        const scanner = new Html5Qrcode("reader");

        try {
          const devices = await Html5Qrcode.getCameras();
          if (!devices.length) return;

          await scanner.start(
            { facingMode: "environment" },
            { fps: 10, qrbox: 250 },
            async (decodedText) => {
              try {
                await scanner.stop();
              } catch { }
              qrScannerRef.current = null;

              if (/^https?:\/\//.test(decodedText)) {
                window.location.href = decodedText;
              } else {
                setQrResult(decodedText);
              }
              setShowQrcode(false);
            }
          );

          qrScannerRef.current = scanner;
        } catch (err) {
          console.error("QR error:", err);
        }
      }
    };

    initQrScanner();

    return () => {
      if (qrScannerRef.current && !isStoppingRef.current) {
        isStoppingRef.current = true;
        qrScannerRef.current
          .stop()
          .then(() => {
            qrScannerRef.current = null;
            isStoppingRef.current = false;
          })
          .catch(() => (isStoppingRef.current = false));
      }
    };
  }, [showQrCode]);

  // =====================================================================
  // RENDER
  // =====================================================================
  return (
    <div className="page-header" ref={containerRef}>
      <div className="nav-bar-header-one">
        <div className="header-logo shadow">
          <Link to="/">
            <img src={noibo} alt="logo" />
          </Link>
        </div>
      </div>

      <div className="header-info" id="mobile-navbar">
        {info && (
          <ul className="list-info-group shadow">
            {/* USER DROPDOWN */}
            <li className={`item-info navbar-item dropdown header-admin ${show ? "show" : ""}`}>
              <button
                className="navbar-nav-link dropdown-toggle"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShow(!show);
                  setShowNoti(false);
                }}
              >
                <div className="admin-title  d-none d-sm-block">
                  <p className="item-title">{info.fullname}</p>
                </div>
                <div className="admin-img">
                  <img src={info.avatar || Avatar} alt="Admin" />
                </div>
              </button>

              {/* MENU USER */}
              {show && (
                <div
                  className="dropdown-menu dropdown-menu-right show"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="item-content">
                    <ul className="settings-list">
                      <li>
                        <Link
                          to="/my-profile"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShow(false);
                          }}
                        >
                          <span>Thông tin cá nhân</span>
                        </Link>
                      </li>

                      <li>
                        <a
                          href="#logout"
                          onClick={(e) => {
                            e.stopPropagation();
                            dologout();
                          }}
                        >
                          <span>Đăng xuất</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </li>

            {/* NOTIFICATION DROPDOWN */}
            <li className={`navbar-item notification-bar dropdown ${showNoti ? "show" : ""}`}>
              <button
                className="navbar-nav-link dropdown-toggle button-notification"
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowNoti(!showNoti);
                  setShow(false);
                }}
              >
                <img src={bellIcon} className="icon-notification" />
                {countNoti > 0 && <span className="count-number">{countNoti}</span>}
              </button>

              {showNoti && (
                <div
                  className="dropdown-menu dropdown-menu-right show"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="w-100 d-flex justify-content-end border-bottom">
                    <button
                      className="btn readall"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        markSeenAll();
                      }}
                    >
                      Đánh dấu đọc tất cả
                    </button>
                  </div>

                  {listNotification ? (
                    listNotification.map((item, i) => (
                      <div
                        key={i}
                        className={"notification-item p-2 " + (item.seen === 1 ? "seen" : "")}
                        onClick={(e) => {
                          e.stopPropagation();
                          markSeen(item.id, item.node_url);
                        }}
                      >
                        {item.avatar && <img src={item.avatar} alt="" className="avatar" />}
                        <div className="content pl-2">
                          <div className="w-100">{parse(item.node_type)}</div>
                          <div className="timmer">
                            <small>Lúc {item.time}</small>
                          </div>
                        </div>

                        {item.seen !== 1 && (
                          <div className="btn-seen">
                            <button
                              className="btn p-0"
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                markSeen(item.id);
                              }}
                            >
                              <i className="far fa-dot-circle"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="p-2">Không có thông báo nào</p>
                  )}
                </div>
              )}
            </li>

            <li className={"navbar-item menu-button-group"}>
              <button className="button-menu" type="button" onClick={() => setShowMenu(true)}>
                <img src={menuIcon} className="icon-menubar" />
              </button>
            </li>
          </ul>
        )}
      </div>

      {/* QR MODAL */}
      <Modal
        show={showQrCode}
        onHide={() => {
          setShowQrcode(false);
          if (qrScannerRef.current && !isStoppingRef.current) {
            isStoppingRef.current = true;
            qrScannerRef.current
              .stop()
              .then(() => {
                qrScannerRef.current = null;
                isStoppingRef.current = false;
              })
              .catch(() => (isStoppingRef.current = false));
          }
        }}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Quét mã QR</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="reader" style={{ width: "100%" }} />
          {qrResult && (
            <div className="mt-3 text-center text-info">
              <strong>Kết quả:</strong> {qrResult}
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* Modal menu */}
      <Modal
        show={showMenu}
        onHide={() => {
          setShowMenu(false);
        }}
        animation={true}
        size="md"
        className="modal-menu"
      >
        <Modal.Header>
          <Modal.Title className="d-flex justify-content-between">
            <div className="text-center title"><strong>CÁC DỊCH VỤ MYBHS</strong></div>
            <div className="btn-close-group" >
              <button type="button" className="btn-close" onClick={()=>setShowMenu(false)}>
                <img
                  src={require(`../assets/img/icon-mybhs/close-icon.png`)}
                  alt="close"
                  className="sidebar-icon"
                />
              </button>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SiderBar />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default HeaderBar;
